import {
  getValidPlacements,
  getValidShifts,
  getValidShiftDestinations,
} from '../shiftTicTacToe/engine/gameLogic';

/** Random valid place or shift for turn timeout auto-play. */
export function pickRandomTurnMove(gameState, player) {
  if (!gameState || !player) return null;

  if (gameState.phase === 'placement') {
    const positions = getValidPlacements(gameState.board);
    if (!positions.length) return null;
    const position = positions[Math.floor(Math.random() * positions.length)];
    return { type: 'place', position };
  }

  if (gameState.phase === 'shift') {
    const { selectedPiece, board } = gameState;
    if (selectedPiece != null) {
      const destinations = getValidShiftDestinations(board, selectedPiece);
      if (!destinations.length) return null;
      const to = destinations[Math.floor(Math.random() * destinations.length)];
      return { type: 'shift', from: selectedPiece, to };
    }
    const shifts = getValidShifts(gameState);
    if (!shifts.length) return null;
    const pick = shifts[Math.floor(Math.random() * shifts.length)];
    return { type: 'shift', from: pick.from, to: pick.to };
  }

  return null;
}
